/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import {
  MODELS_DASHBOARD_SET_VIEW,
  MODELS_DASHBOARD_SET_MAP_METRIC,
  SIGN_OUT_USER,
} from '#constants/actionTypes.js';

const initialState = {
  view: 'table',
  mapMetric: 'sel',
};

const dashboardView = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case MODELS_DASHBOARD_SET_VIEW:
      return { ...state, view: payload };
    case MODELS_DASHBOARD_SET_MAP_METRIC:
      return { ...state, mapMetric: payload };
    case SIGN_OUT_USER:
      return initialState;
    default:
      return state;
  }
};

export default dashboardView;
